import { alpha, Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, SxProps, TableCell, TableRow, Theme, Typography } from '@mui/material'
import React, { CSSProperties, memo, useCallback, useEffect, useMemo, useState } from 'react'
import { Position } from '../../proto/generated/position'
import { OptionType, Security, SecurityCategory_CategoryCode, SecuritySnapshot } from '../../proto/generated/security'
import { addOrderAlertMessage, calculateGcd } from '../../util/orders'
import { getSecurityKey } from '../../util/security'
import {
    openConnectAccountDialog,
    OrdersDataType,
    setBasketAnalyzeDetails,
    setBasketId,
    setHoveredOrderIndex,
    setOrderDataFunction,
    setOrderState,
    setOrderType,
    setQuickOrderData, setSelectedStrategy,
    updateOrderHistory
} from '../../reducer/orders.reducer'
import { getCurentOrderPricesFromData } from '../../util/tradepanel'
import commonActions from '../../actions/common.actions'
import { WidgetListItems } from '../../util/sidebar'
import { useDispatch, useSelector } from 'react-redux'
import { selectCommonStore } from '../../selectors/common'
import { Order, OrderStatus, OrderType, Product, TransactionType, Validity } from '../../proto/generated/order'
import { generatePath, useNavigate } from 'react-router-dom'
import ROUTES from '../../assets/routes'
import { selectUnderlyingOptionsTradeData } from '../../selectors/options'
import { fetchOptionChainV2Initial } from '../../util/options'
import { selectSnapshot } from '../../selectors/security'
import { exchangeToJSON, OptionGreeks } from '../../proto/generated/common'
import { WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle } from '../../proto/generated/websocket'
import { getFreshOrdersFromBasketPositions } from '../../util/positions'
import { ExtraSmallButton, NonInteractiveTooltip } from '../custom'
import { PositionAnalyzeOrder } from './selectedStrategyContainer'
import { setLoading } from '../../reducer/positions.reducer'
import { selectUnderlyingFutureExpiries } from '../../selectors/futures'
import { fetchFutureExpiries } from '../../util/futures'
import { setFutureExpiries } from '../../reducer/futures.reducer'
import { toLocaleStringIn } from '../../util/general'
import { selectOrdersData } from '../../selectors/orders'
import AnalyticsManager from '../../analytics/AnalyticsManager'
import { formatLargeNumber } from '../../util/screener'
import { makeSelectQuickModeEnabled, selectPrimaryTradingAccount, selectTradingAccounts } from '../../selectors/user'
import { QuickWidgetTypes } from '../../reducer/user.reducer'
import { PlaceOrModifyOrdersRequest, TradingAccountStatus } from '../../proto/generated/trading-bridge'
import { v4 as uuid } from 'uuid'
import { placeOrModifyOrder } from '../../services/apis/orders'
import ThinArrowRightIcon from '../../assets/icons/ThinArrowRightIcon'
import ThinArrowDownIcon from '../../assets/icons/ThinArrowDownIcon'
import { deepClone } from '@mui/x-data-grid/utils/utils'
import { darkHoverBtnColor, lightHoverBtnColor } from '../../theme/theme'
import { getStrategyChartParamsFromPositionArray } from '../../util/common'
import ExitIcon from '../../assets/icons/ExitIcon'
import MoreHorizontalIcon from '../../assets/icons/MoreHorizontalIcon'
import Chart from '../../assets/icons/Chart'
import TuneOutlinedIcon from '../../assets/icons/TuneOutlinedIcon'
import { Visibility } from '@mui/icons-material'


type Props = {
    basketWisePositions: any
    strategyCode: string
    i: number
    securityCodeToSnapshot: Map<string, SecuritySnapshot>
    showGreeks: boolean
    underlyingSecurity: Security | undefined
    candlesData: WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle[]
}

export const customPositionCellStyle: CSSProperties = {
    textAlign: 'right',
    padding: '5px 5px',
    width: '14%'
}

export const customPositionRowStyle: SxProps<Theme> = {
    borderBottom: '1.5px solid',
    borderColor: theme => theme.palette.background.default,
}

const BasketWisePositionContainer = (props: Props) => {
    return null;
    // const { basketWisePositions, strategyCode, i, securityCodeToSnapshot, showGreeks, underlyingSecurity, candlesData } = props
    // const [open, setOpen] = useState(false)
    // const dispatch = useDispatch()
    // const { rightSideWidget } = useSelector(selectCommonStore)
    // const navigate = useNavigate()
    // const underlyingToken = getSecurityKey(underlyingSecurity?.exchange ?? 0, underlyingSecurity?.code ?? '')
    // const optionExpiries = useSelector(selectUnderlyingOptionsTradeData(underlyingToken))
    // const futureExpiries = useSelector(selectUnderlyingFutureExpiries(underlyingToken))
    // const underlyingSnapshot = useSelector(selectSnapshot(underlyingToken))
    // const QuickModeEnable = useSelector(makeSelectQuickModeEnabled(QuickWidgetTypes.POSITION))
    // const primaryTradingAccount = useSelector(selectPrimaryTradingAccount)
    // const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    // const isopen = Boolean(anchorEl);
    // const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    //     setAnchorEl(event.currentTarget);
    // };

    // const handleClose = () => {
    //     setAnchorEl(null);
    // };
    // const tradingAccounts = useSelector(selectTradingAccounts)
    // const candleResponses = useMemo(() => {
    //     const candles: OptionGreeks[] = []
    //     basketWisePositions.positions.forEach(position => {
    //         const data = candlesData.find((candle) => candle.security?.code === position.security?.code)
    //         const buyTransaction = position?.firstTransactionType === TransactionType.BUY
    //         const positionQuantity = buyTransaction ? position.buyQuantity : position.sellQuantity
    //         if (data?.candle?.optionGreeks) {
    //             candles.push({
    //                 delta: Math.abs(data.candle.optionGreeks.delta * positionQuantity) * (position.delta > 0 ? 1 : -1),
    //                 gamma: Math.abs(data.candle.optionGreeks.gamma * positionQuantity) * (position.gamma > 0 ? 1 : -1),
    //                 vega: Math.abs(data.candle.optionGreeks.vega * positionQuantity) * (position.vega > 0 ? 1 : -1),
    //                 theta: Math.abs(data.candle.optionGreeks.theta * positionQuantity) * (position.theta > 0 ? 1 : -1),
    //                 rho: 0
    //             })
    //         } else {
    //             candles.push({
    //                 delta: position.delta,
    //                 gamma: position.gamma,
    //                 vega: position.vega,
    //                 theta: position.theta,
    //                 rho: 0
    //             })
    //         }
    //     })
    //     return candles
    // }, [basketWisePositions.positions, candlesData])

    // const strategyProfitLoss = useMemo(() => {
    //     if (showGreeks) {
    //         return Math.round(candleResponses.reduce((prev, curr) => prev + curr.vega, 0) * 100) / 100
    //     }
    //     let profit = 0
    //     basketWisePositions.positions.forEach((position) => {
    //         if (position.open) {
    //             const securitySnapshot = securityCodeToSnapshot.get(getSecurityKey(position.security?.exchange ?? 0, position.security?.code ?? ''))
    //             if (securitySnapshot) {
    //                 profit +=
    //                     (position.buyQuantity > 0
    //                         ? ((securitySnapshot.lastTradedPrice || 0) - position.buyAmount / position.buyQuantity) * position.buyQuantity
    //                         : (position.sellAmount / position.sellQuantity - (securitySnapshot.lastTradedPrice || 0)) * position.sellQuantity) / (position.security?.priceMultiplier ?? 100)
    //             }
    //         } else {
    //             profit += (position.sellAmount - position.buyAmount) / (position.security?.priceMultiplier ?? 100)
    //         }
    //     })
    //     return profit
    // }, [basketWisePositions, securityCodeToSnapshot, showGreeks, candleResponses])

    // const StrategyQuantity = useMemo(() => {
    //     return calculateGcd(
    //         basketWisePositions.positions.map((p) => {
    //             return p.buyQuantity ? p.buyQuantity : p.sellQuantity
    //         })
    //     )
    // }, [basketWisePositions])

    // const StrategyQuantityRender = useMemo(() => {
    //     if (showGreeks) {
    //         return toLocaleStringIn(Math.round(candleResponses.reduce((prev, curr) => prev + curr.delta, 0) * 100) / 100)
    //     }
    //     return StrategyQuantity
    // }, [showGreeks, StrategyQuantity, candleResponses])

    // const StrategyAvgPrice = useMemo(() => {
    //     let result = 0
    //     basketWisePositions.positions.forEach((p) => {
    //         if (p?.firstTransactionType === TransactionType.BUY) {
    //             result -= (p.averageBuyPrice * p.buyQuantity) / (p.security?.priceMultiplier ?? 100)
    //         } else {
    //             result += (p.averageSellPrice * p.sellQuantity) / (p.security?.priceMultiplier ?? 100)
    //         }
    //     })
    //     result /= StrategyQuantity
    //     return result.toString()
    // }, [StrategyQuantity, basketWisePositions.positions])

    // const StrategyAvgPriceRender = useMemo(() => {
    //     if (showGreeks) {
    //         return Math.round(candleResponses.reduce((prev, curr) => prev + curr.theta, 0)).toString();
    //     }
    //     return StrategyAvgPrice
    // }, [showGreeks, StrategyAvgPrice, candleResponses])

    // const StrategyLtpPrice = useMemo(() => {
    //     if (showGreeks) {
    //         return candleResponses.reduce((prev, curr) => prev + curr.gamma, 0).toFixed(2)
    //     }
    //     let result = 0
    //     basketWisePositions.positions.forEach((p) => {
    //         if (p.open) {
    //             const secKey = getSecurityKey(p.security?.exchange ?? 0, p.security?.code ?? '')
    //             const sec = securityCodeToSnapshot.get(secKey)
    //             if (p.buyQuantity) {
    //                 result -= ((sec?.lastTradedPrice ?? 0) * p.buyQuantity) / (p.security?.priceMultiplier ?? 100)
    //             } else {
    //                 result += ((sec?.lastTradedPrice ?? 0) * p.sellQuantity) / (p.security?.priceMultiplier ?? 100)
    //             }
    //         } else {
    //             if (p?.firstTransactionType === TransactionType.BUY) {
    //                 result -= (p.averageSellPrice * p.sellQuantity) / (p.security?.priceMultiplier ?? 100)
    //             } else {
    //                 result += (p.averageBuyPrice * p.buyQuantity) / (p.security?.priceMultiplier ?? 100)
    //             }
    //         }
    //     })
    //     result /= StrategyQuantity
    //     return result.toString()
    // }, [StrategyQuantity, basketWisePositions, securityCodeToSnapshot, showGreeks, candleResponses])

    // const redirectToStrategyBuilder = useCallback(() => {
    //     if (underlyingSecurity) {
    //         navigate(
    //             generatePath(ROUTES.strategyBuilder, {
    //                 exchange: exchangeToJSON(underlyingSecurity.exchange),
    //                 symbol: underlyingSecurity.code
    //             })
    //         )
    //     }
    // }, [navigate, underlyingSecurity])

    // const handleSquareOffClick = useCallback(
    //     async (index: number | undefined = undefined) => {
    //         AnalyticsManager.logEvent('Square Off Clicked', { source: 'Positions' })
    //         dispatch(setLoading(true))
    //         if (QuickModeEnable) {
    //             if ((tradingAccounts.length === 0) || (primaryTradingAccount?.status !== TradingAccountStatus.ACTIVE)) {
    //                 AnalyticsManager.logEvent('Place Order Clicked')
    //                 if (tradingAccounts.length === 0) {
    //                     dispatch(openConnectAccountDialog({
    //                         type: 'connect',
    //                         tradingAccountId: primaryTradingAccount.accountId
    //                     }))
    //                 } else {
    //                     dispatch(openConnectAccountDialog({
    //                         type: 'reconnect',
    //                         tradingAccountId: primaryTradingAccount.accountId
    //                     }))
    //                 }
    //             } else {
    //                 AnalyticsManager.logEvent('Place Order Clicked')
    //                 const orderIdArray: string[] = []
    //                 const request: PlaceOrModifyOrdersRequest = {
    //                     tradingAccountId: primaryTradingAccount.accountId ?? '',
    //                     order: (index === undefined ? basketWisePositions.positions : [basketWisePositions.positions.sort((a, b) => (a.security?.strikePrice ?? 0) - (b.security?.strikePrice ?? 0))[index]]).map((position, i) => {
    //                         const newUuid = uuid()
    //                         orderIdArray.push(newUuid)
    //                         const orderDetails = {
    //                             security: {
    //                                 code: position.security?.code ?? '',
    //                                 exchange: position.security?.exchange ?? 0
    //                             },
    //                             transactionType: position.firstTransactionType === TransactionType.BUY ? TransactionType.SELL : TransactionType.BUY,
    //                             orderType: OrderType.MARKET_ORDER,
    //                             quantity: position.firstTransactionType === TransactionType.BUY
    //                                 ? position.buyQuantity
    //                                 : position.sellQuantity ?? position.security?.lotSize,
    //                             product: Product.CNC,
    //                             price: 0,
    //                             triggerPrice: 0.0,
    //                             variety: Variety.REGULAR,
    //                             validity: Validity.DAY,
    //                             clientOrderId: newUuid,
    //                             basketId: basketWisePositions.basketId
    //                         }
    //                         return orderDetails
    //                     })
    //                 }
    //                 try {
    //                     const created = Date.now();
    //                     const response = await placeOrModifyOrder(request)
    //                     const order = response.orderResponse.length ? response.orderResponse[0] : null;
    //                     if (!order) throw new Error();
    //                     const { successful, commitOrder, brokerOrderId, orderId, errorMessage } = order;
    //                     if (!successful) {
    //                         addOrderAlertMessage({
    //                             ...request.order[0],
    //                             status: OrderStatus.FAILED,
    //                             message: errorMessage || 'Unable to place order'
    //                         })
    //                     } else {
    //                         const updateOrder: Order = {
    //                             ...request.order[0],
    //                             brokerOrderId,
    //                             status: OrderStatus.OPEN,
    //                             filledQuantity: 0,
    //                             orderId,
    //                             created
    //                         }
    //                         if (commitOrder) {
    //                             dispatch(updateOrderHistory({ updates: [updateOrder] }))
    //                         }
    //                         addOrderAlertMessage({
    //                             ...updateOrder,
    //                             message: 'Order placed successfully'
    //                         })
    //                     }
    //                 } catch (error: any) {
    //                     addOrderAlertMessage({
    //                         ...request.order[0],
    //                         status: OrderStatus.FAILED,
    //                         message: error.message || 'Unable to place order'
    //                     })
    //                 }
    //             }
    //         } else {
    //             redirectToStrategyBuilder()
    //             let newOptionExpiries = optionExpiries ?? []
    //             if (newOptionExpiries && newOptionExpiries.length <= 0 && underlyingSecurity) {
    //                 const { optionsData } = await fetchOptionChainV2Initial(underlyingSecurity, dispatch)
    //                 newOptionExpiries = optionsData
    //             }
    //             let newFutureExpiries = futureExpiries
    //             if (basketWisePositions.positions.some((p) => p.security?.categoryCode === SecurityCategory_CategoryCode.FUTURES) && !newFutureExpiries.current.length && underlyingSecurity) {
    //                 await fetchFutureExpiries(underlyingSecurity).then(([currentExpiries, pastExpiries]) => {
    //                     newFutureExpiries = {
    //                         current: currentExpiries,
    //                         past: pastExpiries
    //                     }
    //                     const futureSecurities: Security[] = currentExpiries.concat(pastExpiries).map((v) => v.security!)
    //                     window.securityManager.addSecurities(futureSecurities);
    //                     dispatch(
    //                         setFutureExpiries({
    //                             token: getSecurityKey(underlyingSecurity.exchange, underlyingSecurity.code),
    //                             data: newFutureExpiries
    //                         })
    //                     )
    //                 })
    //             }
    //             const { newOrder, newParentSqOffOrder, basketOrderPrices } = await getFreshOrdersFromBasketPositions(basketWisePositions, newOptionExpiries, newFutureExpiries, underlyingToken, underlyingSnapshot, true)
    //             let finalOrder = newOrder
    //             if (index !== undefined && newOrder.length > 0) {
    //                 const copybasket = deepClone(basketWisePositions)
    //                 const sqPositon = copybasket.positions.sort((a, b) => (a.security?.strikePrice ?? 0) - (b.security?.strikePrice ?? 0))[index]
    //                 const key = sqPositon.security.code
    //                 finalOrder = newOrder.filter(o => o.security?.code === key)
    //             }
    //             dispatch(
    //                 setBasketAnalyzeDetails({
    //                     id: basketWisePositions.basketId,
    //                     strategyCode: strategyCode,
    //                     basketPosition: basketWisePositions,
    //                     underlyingSecurity: underlyingSecurity,
    //                     positionOrders: newParentSqOffOrder.map((o) => ({ ...o, readonly: true })),
    //                     positionParentSqrOffOrders: newOrder.map((o) => ({ ...o, readonly: true })),
    //                     positionOrderPrices: basketOrderPrices,
    //                     executedProfit: basketWisePositions.positions
    //                         .filter((position) => !position.open)
    //                         .map((position) => {
    //                             const ltp = position?.firstTransactionType === TransactionType.BUY ? position.averageSellPrice : position.averageBuyPrice

    //                             const pl =
    //                                 (position?.firstTransactionType === TransactionType.BUY
    //                                     ? ((ltp || 0) - position.buyAmount / position.buyQuantity) * position.buyQuantity
    //                                     : (position.sellAmount / position.sellQuantity - (ltp || 0)) * position.sellQuantity) / (position.security?.priceMultiplier ?? 100)
    //                             return pl
    //                         })
    //                         .reduce((curr, prev) => prev + curr, 0)
    //                 })
    //             )

    //             // dispatch(setParentSquareOffOrders(newParentSqOffOrder))
    //             const newPrices = await getCurentOrderPricesFromData(finalOrder, newOptionExpiries, underlyingToken, [])
    //             setOrderDataFunction({ orders: finalOrder, orderPrices: newPrices, token: underlyingToken })
    //             // await setCurentOrderPricesFromData(finalOrder, dispatch, newOptionExpiries, underlyingToken, [])
    //             dispatch(setSelectedStrategy({
    //                 underlyingSecurity,
    //                 strategyCode,
    //                 basketId: basketWisePositions.basketId,
    //                 strategyName: 'Square Off',
    //                 index: 0,
    //                 analyzeAndAdjust: true
    //             }))
    //             dispatch(
    //                 setBasketId({
    //                     basketId: basketWisePositions.basketId,
    //                     batchId: ''
    //                 })
    //             )
    //             // dispatch(setOrderState('square-off'))
    //             dispatch(setOrderState('order'))
    //             dispatch(setOrderType(OrderType.LIMIT_ORDER))
    //             dispatch(setLoading(false))
    //             if (rightSideWidget !== WidgetListItems.POSITIONS) commonActions.dispatchRightSideWidget(dispatch, WidgetListItems.POSITIONS)
    //             return {
    //                 newOrder: finalOrder,
    //                 newOptionExpiries
    //             }
    //         }
    //     }, [
    //     basketWisePositions,
    //     dispatch,
    //     optionExpiries,
    //     futureExpiries,
    //     redirectToStrategyBuilder,
    //     rightSideWidget,
    //     strategyCode,
    //     underlyingSecurity,
    //     underlyingSnapshot,
    //     underlyingToken
    // ])

    // const handleAnalyzeAdjustClick = useCallback(async () => {
    //     redirectToStrategyBuilder()
    //     dispatch(setLoading(true))
    //     let newOptionExpiries = optionExpiries ?? []
    //     if ((!newOptionExpiries || newOptionExpiries.length <= 0) && underlyingSecurity) {
    //         const { optionsData } = await fetchOptionChainV2Initial(underlyingSecurity, dispatch)
    //         newOptionExpiries = optionsData
    //     }
    //     let newFutureExpiries = futureExpiries
    //     if (basketWisePositions.positions.some((p) => p.security?.categoryCode === SecurityCategory_CategoryCode.FUTURES) && !newFutureExpiries.current.length && underlyingSecurity) {
    //         await fetchFutureExpiries(underlyingSecurity).then(([currentExpiries, pastExpiries]) => {
    //             newFutureExpiries = {
    //                 current: currentExpiries,
    //                 past: pastExpiries
    //             }
    //             const futureSecurities: Security[] = currentExpiries.concat(pastExpiries).map((v) => v.security!)
    //             window.securityManager.addSecurities(futureSecurities);
    //             dispatch(
    //                 setFutureExpiries({
    //                     token: getSecurityKey(underlyingSecurity.exchange, underlyingSecurity.code),
    //                     data: newFutureExpiries
    //                 })
    //             )
    //         })
    //     }

    //     const {
    //         newOrder,
    //         newParentSqOffOrder,
    //         basketOrderPrices
    //     } = await getFreshOrdersFromBasketPositions(basketWisePositions, newOptionExpiries, newFutureExpiries, underlyingToken, underlyingSnapshot, false)
    //     dispatch(
    //         setBasketAnalyzeDetails({
    //             id: basketWisePositions.basketId,
    //             strategyCode: strategyCode,
    //             basketPosition: basketWisePositions,
    //             underlyingSecurity: underlyingSecurity,
    //             positionOrders: newOrder.map((o) => ({ ...o, readonly: true })),
    //             positionParentSqrOffOrders: newParentSqOffOrder.map((o) => ({ ...o, readonly: true })),
    //             positionOrderPrices: basketOrderPrices,
    //             executedProfit: basketWisePositions.positions
    //                 .filter((position) => !position.open)
    //                 .map((position) => {
    //                     const ltp = position?.firstTransactionType === TransactionType.BUY ? position.averageSellPrice : position.averageBuyPrice

    //                     const pl =
    //                         (position?.firstTransactionType === TransactionType.BUY
    //                             ? ((ltp || 0) - position.buyAmount / position.buyQuantity) * position.buyQuantity
    //                             : (position.sellAmount / position.sellQuantity - (ltp || 0)) * position.sellQuantity) / (position.security?.priceMultiplier ?? 100)
    //                     return pl
    //                 })
    //                 .reduce((curr, prev) => prev + curr, 0)
    //         })
    //     )
    //     setOrderDataFunction({
    //         orders: [],
    //         token: getSecurityKey(underlyingSecurity?.exchange ?? 0, underlyingSecurity?.code ?? '')
    //     })
    //     dispatch(
    //         setSelectedStrategy({
    //             underlyingSecurity,
    //             strategyCode,
    //             basketId: basketWisePositions.basketId,
    //             strategyName: 'Analyze/Adjust',
    //             index: 0,
    //             analyzeAndAdjust: true
    //         }))
    //     dispatch(
    //         setBasketId({
    //             basketId: basketWisePositions.basketId,
    //             batchId: ''
    //         })
    //     )
    //     dispatch(setOrderState('order'))
    //     dispatch(setOrderType(OrderType.LIMIT_ORDER))
    //     dispatch(setLoading(false))
    //     if (rightSideWidget !== WidgetListItems.POSITIONS) commonActions.dispatchRightSideWidget(dispatch, WidgetListItems.POSITIONS)
    // }, [
    //     basketWisePositions,
    //     dispatch,
    //     optionExpiries,
    //     futureExpiries,
    //     redirectToStrategyBuilder,
    //     rightSideWidget,
    //     strategyCode,
    //     underlyingSecurity,
    //     underlyingSnapshot,
    //     underlyingToken
    // ])

    // const handleCustomSquareOffClick = useCallback(
    //     async (position: Position) => {
    //         if (QuickModeEnable) {
    //             if (!primaryTradingAccount || !tradingAccounts || tradingAccounts.length === 0) {
    //                 dispatch(openConnectAccountDialog({
    //                     type: 'connect',
    //                     tradingAccountId: primaryTradingAccount.accountId
    //                 }))
    //             } else if (primaryTradingAccount.status !== TradingAccountStatus.ACTIVE) {
    //                 dispatch(openConnectAccountDialog({
    //                     type: 'reconnect',
    //                     tradingAccountId: primaryTradingAccount.accountId
    //                 }))
    //             } else {
    //                 const clientOrderId = uuid()
    //                 const request: PlaceOrModifyOrdersRequest = {
    //                     tradingAccountId: primaryTradingAccount.accountId ?? '',
    //                     order: [{
    //                         security: {
    //                             code: position.security?.code ?? '',
    //                             exchange: position.security?.exchange ?? 0
    //                         },
    //                         transactionType: position.firstTransactionType === TransactionType.BUY ? TransactionType.SELL : TransactionType.BUY,
    //                         orderType: OrderType.MARKET_ORDER,
    //                         quantity: position.firstTransactionType === TransactionType.BUY
    //                             ? position.buyQuantity
    //                             : position.sellQuantity ?? position.security?.lotSize,
    //                         product: Product.CNC,
    //                         price: 0,
    //                         triggerPrice: 0,
    //                         variety: Variety.REGULAR,
    //                         validity: Validity.DAY,
    //                         clientOrderId: clientOrderId
    //                     }]
    //                 }
    //                 try {
    //                     const created = Date.now();
    //                     const response = await placeOrModifyOrder(request)
    //                     const order = response.orderResponse.length ? response.orderResponse[0] : null;
    //                     if (!order) throw new Error();
    //                     const { successful, commitOrder, brokerOrderId, orderId, errorMessage } = order;
    //                     if (!successful) {
    //                         addOrderAlertMessage({
    //                             ...request.order[0],
    //                             status: OrderStatus.FAILED,
    //                             message: errorMessage || 'Unable to place order'
    //                         })
    //                     } else {
    //                         const updateOrder: Order = {
    //                             ...request.order[0],
    //                             brokerOrderId,
    //                             status: OrderStatus.OPEN,
    //                             filledQuantity: 0,
    //                             orderId,
    //                             created
    //                         }
    //                         if (commitOrder) {
    //                             dispatch(updateOrderHistory({ updates: [updateOrder] }))
    //                         }
    //                         addOrderAlertMessage({
    //                             ...updateOrder,
    //                             message: 'Order placed successfully',
    //                         })
    //                     }
    //                 } catch (error: any) {
    //                     addOrderAlertMessage({
    //                         ...request.order[0],
    //                         status: OrderStatus.FAILED,
    //                         message: error.message || 'Unable to place order'
    //                     })
    //                 }
    //             }
    //         } else {
    //             const { firstTransactionType, buyQuantity, sellQuantity } = position
    //             const quantity = firstTransactionType === TransactionType.BUY ? buyQuantity : sellQuantity
    //             if (primaryTradingAccount?.accountId) {
    //                 dispatch(
    //                     setQuickOrderData({
    //                         openDialog: true,
    //                         type: 'trade',
    //                         transactionType: position.firstTransactionType === TransactionType.BUY ? TransactionType.SELL : TransactionType.BUY,
    //                         security: position.security,
    //                         isSquareOffOrder: true,
    //                         editOrder: undefined,
    //                         orderType: OrderType.LIMIT_ORDER,
    //                         product: Product.CNC,
    //                         price: undefined,
    //                         quantity,
    //                         maxQuantity: quantity,
    //                         tradingAccountId: primaryTradingAccount.accountId
    //                     })
    //                 )
    //             }
    //             return
    //         }
    //     },
    //     [QuickModeEnable, primaryTradingAccount, tradingAccounts, dispatch]
    // )

    // const strategyChartPath = useCallback(() => {
    //     const openPositions = basketWisePositions.positions.filter(p => p.open)
    //     if (openPositions.length === 0) return ''
    //     const { param } = getStrategyChartParamsFromPositionArray(openPositions)
    //     window.open(generatePath(ROUTES.spread, { spread: param }), '_blank')
    // }, [basketWisePositions.positions])

    // return (
    //     <>
    //         {
    //             strategyCode === 'CUSTOM' && basketWisePositions.basketId === 'default' ? null : (
    //                 <TableRow
    //                     onClick={() => setOpen(!open)}
    //                     sx={{
    //                         position: 'relative',
    //                         '&:hover .strategy-actions': {
    //                             visibility: 'visible !important'
    //                         },
    //                         maxWidth: '100%',
    //                         opacity: basketWisePositions.positions.every((p) => !p.open) ? 0.5 : 1,
    //                         borderBottom: '1.5px solid',
    //                         borderColor: theme => theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.08)',
    //                     }}
    //                 >
    //                     <TableCell sx={{ cursor: 'pointer', width: '5%', padding: 0, textAlign: 'center' }}>
    //                         {open ? <ThinArrowDownIcon /> : <ThinArrowRightIcon />}
    //                     </TableCell>
    //                     <TableCell sx={{ padding: '5px', width: '35%', overflow: 'hidden' }}>
    //                         <Typography color={'textSecondary'} sx={{ fontSize: '12px', opacity: (basketWisePositions.positions.length > 0 ? 1 : 0.5), overflow: 'hidden', whiteSpace: 'nowrap' }}
    //                             title={`${underlyingSecurity?.symbol ?? ''} ${strategyCode}${i === 0 ? '' : ' ' + (i + 1)}`} >
    //                             {`${underlyingSecurity?.symbol ?? ''} ${strategyCode}${i === 0 ? '' : ' ' + (i + 1)}`}
    //                         </Typography>
    //                     </TableCell>
    //                     <TableCell sx={{ width: '5%', padding: 0, textAlign: 'center', overflow: 'hidden' }}>
    //                         <Typography variant="button" className={`${Number(StrategyAvgPrice) <= 0 ? 'green-text' : 'red-text'}`}>
    //                             {Number(StrategyAvgPrice) <= 0 ? 'B' : 'S'}
    //                         </Typography>
    //                     </TableCell>
    //                     <TableCell
    //                         style={{
    //                             ...customPositionCellStyle,
    //                             width: showGreeks ? 'auto' : '14%'
    //                         }} sx={{ overflowX: 'hidden' }}
    //                         className="font-feature-num"
    //                     >
    //                         {StrategyQuantityRender}
    //                     </TableCell>
    //                     <TableCell
    //                         style={{
    //                             ...customPositionCellStyle,
    //                             width: showGreeks ? 'auto' : '18%'
    //                         }} sx={{ overflowX: 'hidden' }}
    //                         className="font-feature-num"
    //                     >
    //                         {StrategyAvgPriceRender}
    //                     </TableCell>


    //                     <TableCell
    //                         style={{
    //                             ...customPositionCellStyle,
    //                             width: showGreeks ? 'auto' : '18%'
    //                         }} sx={{ overflowX: 'hidden' }}
    //                         className="font-feature-num"
    //                     >
    //                         {showGreeks ? toLocaleStringIn(Number(StrategyLtpPrice)) : toLocaleStringIn(Number(StrategyAvgPrice) <= 0 ? -1 * Number(StrategyLtpPrice) : Number(StrategyLtpPrice))}
    //                     </TableCell>
    //                     <TableCell
    //                         style={{
    //                             ...customPositionCellStyle,
    //                             width: showGreeks ? 'auto' : '18%'
    //                         }} sx={{ overflowX: 'hidden' }}
    //                         className={`${showGreeks ? '' : strategyProfitLoss < 0 ? 'red-text' : 'green-text'} font-feature-num`}
    //                     >
    //                         {showGreeks ? formatLargeNumber(strategyProfitLoss) : toLocaleStringIn(strategyProfitLoss)}
    //                     </TableCell>
    //                     <Box sx={{
    //                         position: 'absolute',
    //                         right: 0,
    //                         visibility: isopen ? 'visible' : 'hidden',
    //                         background: (theme) => alpha(theme.palette.background.paper, 0.9),
    //                         height: '30px',
    //                         top: 0
    //                     }} className="font-feature-num strategy-actions">
    //                         {basketWisePositions.positions.length > 0 &&
    //                             basketWisePositions.basketId !== 'default' &&
    //                             !basketWisePositions.positions.every((p) => !p.open) ? (
    //                             <>
    //                                 <ExtraSmallButton
    //                                     size="small"
    //                                     onClick={(e) => {
    //                                         e.stopPropagation()
    //                                         handleClick(e)
    //                                     }}
    //                                     sx={{ float: 'right', p: 0, height: '30px', borderRadius: '0 !important' }}
    //                                 >
    //                                     <MoreHorizontalIcon fontSize="small" />
    //                                 </ExtraSmallButton>
    //                                 <Menu
    //                                     anchorEl={anchorEl}
    //                                     open={isopen}
    //                                     onClose={(event, reason) => {

    //                                         if (event && "stopPropagation" in event) {
    //                                             (event as any).stopPropagation();
    //                                         }
    //                                         handleClose();
    //                                     }}
    //                                     anchorOrigin={{
    //                                         vertical: 'bottom',
    //                                         horizontal: 'right',
    //                                     }}
    //                                     transformOrigin={{
    //                                         vertical: 'top',
    //                                         horizontal: 'right',
    //                                     }}
    //                                     disableAutoFocusItem
    //                                     disableEnforceFocus
    //                                     PaperProps={{
    //                                         onClick: (e) => e.stopPropagation(),

    //                                         sx: {

    //                                             '& .MuiMenu-list': {
    //                                                 paddingTop: 0,
    //                                                 paddingBottom: 0,
    //                                             },
    //                                         },
    //                                     }}

    //                                 >
    //                                     <MenuItem onClick={(e) => {
    //                                         e.stopPropagation()
    //                                         handleSquareOffClick()
    //                                     }} sx={{ px: '5px' }}>
    //                                         <ListItemIcon sx={{ minWidth: '30px !important' }}>
    //                                             <ExitIcon fontSize='small' />
    //                                         </ListItemIcon>
    //                                         <ListItemText>
    //                                             <Typography fontSize={'12px'}>Square Off</Typography>
    //                                         </ListItemText>
    //                                     </MenuItem>
    //                                     <MenuItem onClick={(e) => {
    //                                         e.stopPropagation()
    //                                         handleAnalyzeAdjustClick()
    //                                     }} sx={{ px: '5px' }}>
    //                                         <ListItemIcon sx={{ minWidth: '30px !important' }}>
    //                                             <TuneOutlinedIcon sx={{ fontSize: '10px' }} />
    //                                         </ListItemIcon>
    //                                         <ListItemText>
    //                                             <Typography fontSize={'12px'}>Adjust/Analyze</Typography>
    //                                         </ListItemText>
    //                                     </MenuItem>
    //                                     <MenuItem onClick={(e) => {
    //                                         e.stopPropagation()
    //                                         strategyChartPath()
    //                                     }} sx={{ px: '5px' }}>
    //                                         <ListItemIcon sx={{ minWidth: '30px !important' }}>
    //                                             <Chart sx={{ height: '24px', width: '24px' }} strokeWidth={1} />
    //                                         </ListItemIcon>
    //                                         <ListItemText>
    //                                             <Typography fontSize={'12px'}>Strategy Chart</Typography>
    //                                         </ListItemText>
    //                                     </MenuItem>
    //                                 </Menu>
    //                             </>
    //                         ) : null}
    //                     </Box>
    //                     {/* {basketWisePositions.positions.length > 0 && basketWisePositions.basketId !== 'default' && !basketWisePositions.positions.every((p) => !p.open) ? (
    //                         <Box
    //                             className="strategy-actions"
    //                             sx={{
    //                                 position: 'absolute',
    //                                 top: 0,
    //                                 right: 0,
    //                                 display: 'flex',
    //                                 gap: 0.5,
    //                                 visibility: 'hidden',
    //                                 background: (theme) => alpha(theme.palette.background.paper, 0.7),
    //                                 alignItems: 'center'
    //                             }}
    //                             onClick={(e) => e.stopPropagation()}
    //                         >
    //                             <NonInteractiveTooltip title="Analyze/Adjust" placement={'bottom'} arrow sx={{ zIndex: 999999999999999 }}>
    //                                 <ExtraSmallButton
    //                                     size="small"
    //                                     onClick={(e) => {
    //                                         e.stopPropagation()
    //                                         handleAnalyzeAdjustClick()
    //                                     }}
    //                                 >
    //                                     <TuneOutlined fontSize="small" />
    //                                 </ExtraSmallButton>
    //                             </NonInteractiveTooltip>
    //                             <NonInteractiveTooltip title="Square off" placement={'bottom'} arrow sx={{ zIndex: 999999999999999 }}>
    //                                 <ExtraSmallButton
    //                                     onClick={()=>handleSquareOffClick()}
    //                                     size="small"
    //                                 >
    //                                     <ExitToAppOutlined fontSize="small" />
    //                                 </ExtraSmallButton>
    //                             </NonInteractiveTooltip>
    //                         </Box>
    //                     ) : null} */}
    //                 </TableRow>
    //             )
    //             // : null
    //         }
    //         {((strategyCode === 'CUSTOM' && basketWisePositions.basketId === 'default') || open) &&
    //             [...basketWisePositions.positions]
    //                 .sort((a, b) => (a.security?.strikePrice ?? 0) - (b.security?.strikePrice ?? 0))
    //                 .map((position, j) => {
    //                     return (
    //                         <BasketPositionTableRow
    //                             candlesData={candlesData}
    //                             key={`${position.security?.code} ${strategyCode} ${i} ${j + 1}`}
    //                             position={position}
    //                             // showSquareOffButton={basketWisePositions.basketId === 'default'}
    //                             strategyCode={strategyCode}
    //                             i={j}
    //                             securityCodeToSnapshot={securityCodeToSnapshot}
    //                             showGreeks={showGreeks}
    //                             basketId={basketWisePositions.basketId}
    //                             handleCustomSquareOffClick={basketWisePositions.basketId === 'default' ? handleCustomSquareOffClick : () => handleSquareOffClick(j)}
    //                             rowIndex={j}
    //                             isLastRow={i === basketWisePositions.positions.length - 1 && j === basketWisePositions.positions.length - 1}
    //                         />
    //                     )
    //                 })}
    //     </>
    // )
}

type BasketProps = {
    position: Position
    strategyCode: string
    i: number
    securityCodeToSnapshot: Map<string, SecuritySnapshot>
    showGreeks: boolean
    handleCustomSquareOffClick: (position: Position) => void
    squaredOffOrder?: OrdersDataType
    squaredOffPosition?: PositionAnalyzeOrder
    sameOrderTypePosition?: PositionAnalyzeOrder
    basketId: string
    showSquareOffButton?: boolean
    showSquareOffButtonOnHover?: boolean
    candlesData: WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle[],
    rowIndex: number
    isLastRow?: boolean,
    orderHoverDetect?: boolean
    strategyContainer?: boolean
}

export const BasketPositionTableRow = ({
    securityCodeToSnapshot,
    position,
    strategyCode,
    showGreeks,
    sameOrderTypePosition,
    i,
    handleCustomSquareOffClick,
    basketId,
    showSquareOffButton = true,
    showSquareOffButtonOnHover = false,
    squaredOffPosition,
    candlesData,
    isLastRow = false,
    rowIndex,
    orderHoverDetect = false,
    strategyContainer = false
}: BasketProps) => {

    return null;
    // const dispatch = useDispatch()
    // const priceMultiplier = useMemo(() => position.security?.priceMultiplier ?? 100, [position.security?.priceMultiplier])
    // const buyTransaction = useMemo(() => position?.firstTransactionType === TransactionType.BUY, [position?.firstTransactionType])
    // const positionQuantity = useMemo(() => (buyTransaction ? position.buyQuantity : position.sellQuantity), [position, buyTransaction])
    // const squaredOffQuantity = useMemo(() => (squaredOffPosition ? squaredOffPosition.quantity : 0), [squaredOffPosition])
    // const sameOrderTypeQuantity = useMemo(() => (sameOrderTypePosition ? sameOrderTypePosition.quantity : 0), [sameOrderTypePosition])
    // const { hoveredOrderIndex } = useSelector(selectOrdersData)
    // const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null);

    // const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    //     setMenuAnchorEl(event.currentTarget);
    // };

    // const handleClose = () => {
    //     setMenuAnchorEl(null);
    // };

    // const ltp = useMemo(
    //     () => {
    //         let currentLtp = position?.open
    //             ? securityCodeToSnapshot.get(getSecurityKey(position.security?.exchange ?? 0, position.security?.code ?? ''))?.lastTradedPrice ?? 0
    //             : buyTransaction
    //                 ? position.averageSellPrice
    //                 : position.averageBuyPrice
    //         if (squaredOffPosition) {
    //             const leftQuantity = ((buyTransaction ? position.buyQuantity : position.sellQuantity) - squaredOffPosition.quantity)
    //             currentLtp = ((currentLtp * leftQuantity) + (squaredOffPosition.averagePrice * squaredOffPosition.quantity)) / (leftQuantity + squaredOffPosition.quantity)
    //         }
    //         return currentLtp
    //     },
    //     [position?.open, position.security?.exchange, position.security?.code, position.averageSellPrice, position.averageBuyPrice, position.buyQuantity, position.sellQuantity, securityCodeToSnapshot, buyTransaction, squaredOffPosition]
    // )

    // const avg = useMemo(
    //     () => {
    //         if (sameOrderTypePosition) {
    //             return (
    //                 ((buyTransaction ? (position.averageBuyPrice * position.buyQuantity) : (position.averageSellPrice * position.sellQuantity)) + (sameOrderTypePosition.averagePrice * sameOrderTypePosition.quantity))
    //                 / ((buyTransaction ? position.buyQuantity : position.sellQuantity) + sameOrderTypePosition.quantity)
    //             ) / (priceMultiplier ?? 100)
    //         }
    //         return (buyTransaction ? position.averageBuyPrice : position.averageSellPrice) / (priceMultiplier ?? 100)
    //     },
    //     [sameOrderTypePosition, buyTransaction, position.averageBuyPrice, position.averageSellPrice, position.buyQuantity, position.sellQuantity, priceMultiplier]
    // )
    // const pl = useMemo(() => {
    //     let profitLoss =
    //         (buyTransaction ? ((ltp || 0) - position.buyAmount / position.buyQuantity) * position.buyQuantity : (position.sellAmount / position.sellQuantity - (ltp || 0)) * position.sellQuantity) /
    //         (priceMultiplier ?? 100)
    //     if (squaredOffPosition) {
    //         profitLoss = (buyTransaction ? ((ltp || 0) - (avg * priceMultiplier)) * (position.buyQuantity) : ((avg * priceMultiplier) - (ltp || 0)) * (position.sellQuantity)) /
    //             (priceMultiplier ?? 100)
    //     }
    //     if (sameOrderTypePosition) {
    //         profitLoss = (buyTransaction ? (((ltp || 0) - (avg * priceMultiplier)) * (position.buyQuantity + sameOrderTypePosition.quantity)) : (((avg * priceMultiplier) - (ltp || 0)) * (position.sellQuantity + sameOrderTypePosition.quantity))) / (priceMultiplier ?? 100)
    //     }
    //     return profitLoss
    // }, [buyTransaction, ltp, position, priceMultiplier, squaredOffPosition, sameOrderTypePosition, avg])

    // const [currentCandleResponse, setCurrentCandleResponse] = useState<WebSocketResponseMessage_CandleSubscriptionResponse_SecurityCandle | undefined>(undefined)
    // const displayName = useMemo(() => {
    //     let result = position.security?.symbol
    //     if (position.security?.categoryCode === SecurityCategory_CategoryCode.OPTIONS) {
    //         const expiry = new Date(position.security?.expiry?.expiry ?? 0)
    //         const day = expiry.getDate()
    //         const month = expiry.toLocaleString('en', { month: 'short' }).toUpperCase()
    //         const year = expiry.getFullYear()
    //         const currentYear = new Date().getFullYear()
    //         if (year === currentYear) {
    //             result = `${day} ${month}`
    //         } else {
    //             result = `${day} ${month} ${year.toString().slice(-2)}`
    //         }
    //         result += ` ${(position.security.strikePrice ?? 0) / (position.security.priceMultiplier ?? 100)} ${position.security.optionType === OptionType.CE ? 'CE' : 'PE'}`
    //     }
    //     return result
    // }, [position])

    // useEffect(() => {
    //     const currentCandle = candlesData.find((candle) => candle.security?.code === position.security?.code)
    //     if (currentCandle) {
    //         setCurrentCandleResponse(currentCandle)
    //     }
    // }, [position, candlesData])

    // const showSquarredOffOrder = useMemo(() => {
    //     return Boolean(squaredOffPosition) && squaredOffQuantity > positionQuantity + sameOrderTypeQuantity
    // }, [squaredOffPosition, squaredOffQuantity, positionQuantity, sameOrderTypeQuantity])

    // const BasketPositionRowCells = ({ isSquaredOffOrder, hideAddedOrRemoved = false, isLastRow }: {
    //     isSquaredOffOrder: boolean;
    //     hideAddedOrRemoved: boolean
    //     isLastRow: boolean
    // }) => {
    //     const emptyTableCell = useMemo(() => {
    //         return (
    //             <TableCell sx={{
    //                 width: '5%', padding: 0, textAlign: 'center',
    //                 borderBottom: '1.5px solid',
    //                 borderColor: theme => {
    //                     const base = theme.palette.background.default;

    //                     if (basketId !== "default" && strategyCode === "CUSTOM") {
    //                         return alpha(base, isLastRow ? 1 : 0.06);
    //                     } else {
    //                         return alpha(base, 1);
    //                     }
    //                 }
    //             }} color={'textSecondary'}>
    //                 <Typography
    //                     color={'textSecondary'} >{isSquaredOffOrder ? '+' : hideAddedOrRemoved ? '' : '-'}</Typography>
    //             </TableCell>
    //         )
    //     }, [hideAddedOrRemoved, isSquaredOffOrder])

    //     const displayNameCell = useMemo(() => {
    //         return (
    //             <TableCell
    //                 sx={{
    //                     padding: '5px',
    //                     width: '35%',
    //                     borderBottom: "1.5px solid",
    //                     borderColor: theme => {
    //                         const base = theme.palette.background.default;

    //                         if (basketId !== "default" && strategyCode === "CUSTOM") {
    //                             return alpha(base, isLastRow ? 1 : 0.06);
    //                         } else {
    //                             return alpha(base, 1);
    //                         }
    //                     }
    //                 }}
    //             >
    //                 <Typography color={'textSecondary'} sx={{
    //                     fontSize: '12px',
    //                     // marginLeft: !showSquareOffButton ? '16px' : 0,
    //                     marginLeft: 0,
    //                     overflow: 'hidden',
    //                     whiteSpace: 'nowrap'
    //                 }}>
    //                     {basketId === 'default' && strategyCode === 'CUSTOM' ? position.security?.symbol : displayName}
    //                 </Typography>
    //             </TableCell>
    //         )
    //     }, [])

    //     const buySellTypeCell = useMemo(() => {
    //         return (
    //             <TableCell sx={{
    //                 width: '5%', padding: 0, textAlign: 'center',
    //                 borderBottom: '1.5px solid',
    //                 borderColor: theme => {
    //                     const base = theme.palette.background.default;

    //                     if (basketId !== "default" && strategyCode === "CUSTOM") {
    //                         return alpha(base, isLastRow ? 1 : 0.06);
    //                     } else {
    //                         return alpha(base, 1);
    //                     }
    //                 },
    //                 overflow: 'hidden'
    //             }}>
    //                 <Typography variant="button" className={`${buyTransaction && !isSquaredOffOrder ? 'green-text' : 'red-text'}`} component="span"
    //                 //style={{ backgroundColor: basketId !== 'default' && strategyCode === 'CUSTOM' ? "grey.100" : "none" }}
    //                 >
    //                     {buyTransaction && !isSquaredOffOrder ? 'B' : 'S'}
    //                 </Typography>
    //             </TableCell>
    //         )
    //     }, [isSquaredOffOrder])

    //     const quantityOrDeltaCell = useMemo(() => {
    //         const showNewQuantity = !isSquaredOffOrder && sameOrderTypeQuantity !== (squaredOffQuantity ?? 0);
    //         const getDeltaValue = () => {
    //             if (!showGreeks) return null;
    //             const delta = currentCandleResponse?.candle?.optionGreeks?.delta ?? position.delta;
    //             if (delta == null || delta === 0) return '-';
    //             if (delta === position.delta) return delta.toFixed(2);
    //             const scaled = Math.abs(delta * positionQuantity) * (position.delta > 0 ? 1 : -1);
    //             return scaled.toFixed(2);
    //         };

    //         const primaryValue = showGreeks
    //             ? getDeltaValue()
    //             : isSquaredOffOrder
    //                 ? squaredOffQuantity - positionQuantity
    //                 : positionQuantity;

    //         const secondaryValue = showNewQuantity
    //             ? showGreeks
    //                 ? getDeltaValue()
    //                 : squaredOffQuantity > positionQuantity + sameOrderTypeQuantity
    //                     ? 0
    //                     : positionQuantity + sameOrderTypeQuantity - squaredOffQuantity
    //             : null;

    //         return (
    //             <TableCell
    //                 style={{
    //                     ...customPositionCellStyle,
    //                     width: '10% !important',
    //                     textDecoration: showGreeks || position.open ? '' : 'line-through',
    //                 }}
    //                 sx={{
    //                     borderBottom: '1.5px solid',
    //                     borderColor: theme => {
    //                         const base = theme.palette.background.default;

    //                         if (basketId !== "default" && strategyCode === "CUSTOM") {
    //                             return alpha(base, isLastRow ? 1 : 0.06);
    //                         } else {
    //                             return alpha(base, 1);
    //                         }
    //                     },
    //                     overflow: 'hidden'
    //                 }}
    //                 className="font-feature-num"
    //             >
    //                 <Typography component="span" sx={{
    //                     textDecoration: showNewQuantity ? 'line-through' : '',
    //                     // backgroundColor: basketId !== 'default' && strategyCode === 'CUSTOM' ? "grey.100" : "transparent" 
    //                 }}
    //                     fontSize="14px">
    //                     {primaryValue ?? '-'}
    //                 </Typography>
    //                 {secondaryValue !== null && (
    //                     <Typography component="span" fontSize="14px" sx={{ pl: 0.5 }} style={{ backgroundColor: basketId !== 'default' && strategyCode === 'CUSTOM' ? "grey.100" : "transparent" }}>
    //                         {secondaryValue}
    //                     </Typography>
    //                 )}
    //             </TableCell>
    //         )
    //     }, [isSquaredOffOrder])

    //     const averageOrThetaCell = useMemo(() => {
    //         const getThetaValue = () => {
    //             if (!showGreeks) return null;
    //             const theta = currentCandleResponse?.candle?.optionGreeks?.theta ?? position.theta;
    //             if (theta == null || theta === 0) return '-';
    //             if (theta === position.theta) return theta.toFixed(2);
    //             const scaled = Math.abs(theta * positionQuantity) * (position.theta > 0 ? 1 : -1);
    //             return scaled.toFixed(0);
    //         };
    //         const displayValue = showGreeks
    //             ? getThetaValue()
    //             : isSquaredOffOrder
    //                 ? toLocaleStringIn(squaredOffPosition?.avg ?? 0)
    //                 : toLocaleStringIn(avg);

    //         return (
    //             <TableCell
    //                 style={{
    //                     ...customPositionCellStyle,
    //                     width: showGreeks ? 'auto' : '12%'
    //                 }}
    //                 sx={{
    //                     borderBottom: '1.5px solid',
    //                     borderColor: theme => {
    //                         const base = theme.palette.background.default;

    //                         if (basketId !== "default" && strategyCode === "CUSTOM") {
    //                             return alpha(base, isLastRow ? 1 : 0.06);
    //                         } else {
    //                             return alpha(base, 1);
    //                         }
    //                     }
    //                 }}
    //                 className="font-feature-num"
    //             >
    //                 <Typography style={{
    //                     fontSize: "14px"
    //                     //backgroundColor: basketId !== 'default' && strategyCode === 'CUSTOM' ? "grey.100" : "transparent" 
    //                 }}>{displayValue}</Typography>
    //             </TableCell>
    //         );
    //     }, [isSquaredOffOrder]);

    //     const ltpOrGammaCell = useMemo(() => {
    //         const getGammaValue = () => {
    //             if (!showGreeks) return null;
    //             const gamma = currentCandleResponse?.candle?.optionGreeks?.gamma ?? position.gamma;
    //             if (gamma == null || gamma === 0) return '-';
    //             if (gamma === position.gamma) return gamma.toFixed(2);
    //             const scaled = Math.abs(gamma * positionQuantity) * (position.gamma > 0 ? 1 : -1);
    //             return scaled.toFixed(2);
    //         };
    //         const displayValue = showGreeks
    //             ? getGammaValue()
    //             : toLocaleStringIn((isSquaredOffOrder ? (squaredOffPosition?.ltp ?? 0) : ltp) / (priceMultiplier ?? 100));

    //         return (
    //             <TableCell
    //                 style={{
    //                     ...customPositionCellStyle,
    //                     width: showGreeks ? 'auto' : '14%'
    //                 }}
    //                 sx={{
    //                     borderBottom: '1.5px solid',
    //                     borderColor: theme => {
    //                         const base = theme.palette.background.default;

    //                         if (basketId !== "default" && strategyCode === "CUSTOM") {
    //                             return alpha(base, isLastRow ? 1 : 0.06);
    //                         } else {
    //                             return alpha(base, 1);
    //                         }
    //                     },
    //                     overflow: 'hidden'
    //                 }}
    //                 className="font-feature-num"
    //             >
    //                 {displayValue}
    //             </TableCell>
    //         )
    //     }, [isSquaredOffOrder])

    //     const plOrVegaCell = useMemo(() => {
    //         // const profitLoss = isSquaredOffOrder ? squaredOffPosition!.pl : pl
    //         const profitLoss = isSquaredOffOrder ? pl : pl
    //         const getVegaValue = () => {
    //             if (!showGreeks) return null;
    //             const vega = currentCandleResponse?.candle?.optionGreeks?.vega ?? position.vega;
    //             if (vega == null || vega === 0) return '-';
    //             if (vega === position.vega) return formatLargeNumber(vega)
    //             const scaled = Math.abs(vega * positionQuantity) * (position.gamma > 0 ? 1 : -1);
    //             return formatLargeNumber(scaled)
    //         };
    //         const displayValue = showGreeks
    //             ? getVegaValue()
    //             : toLocaleStringIn(profitLoss);
    //         return (
    //             <TableCell
    //                 style={{
    //                     ...customPositionCellStyle,
    //                     width: showGreeks ? 'auto' : '18%'
    //                 }}
    //                 sx={{
    //                     borderBottom: '1.5px solid',
    //                     borderColor: theme => {
    //                         const base = theme.palette.background.default;

    //                         if (basketId !== "default" && strategyCode === "CUSTOM") {
    //                             return alpha(base, isLastRow ? 1 : 0.06);
    //                         } else {
    //                             return alpha(base, 1);
    //                         }
    //                     },
    //                     overflow: 'hidden', whiteSpace: 'nowrap',
    //                 }}
    //                 className={`${showGreeks || !Number.isFinite(profitLoss) ? '' : profitLoss < 0 ? 'red-text' : 'green-text'} font-feature-num`}
    //             >
    //                 {displayValue}
    //             </TableCell>
    //         )
    //     }, [isSquaredOffOrder])

    //     return (
    //         <>
    //             {emptyTableCell}
    //             {displayNameCell}
    //             {buySellTypeCell}
    //             {quantityOrDeltaCell}
    //             {averageOrThetaCell}
    //             {ltpOrGammaCell}
    //             {plOrVegaCell}
    //         </>
    //     )
    // }

    // const squareOffIcon = useCallback((sx: SxProps = { right: 0 }) => (
    //     <NonInteractiveTooltip key={position.security?.code ?? ''} title="Square off" arrow placement="bottom" sx={{ zIndex: 999999999999999 }}>
    //         <Box
    //             className="hover-button"
    //             sx={{
    //                 visibility: 'hidden',
    //                 position: 'absolute',
    //                 top: '0px',
    //                 display: 'flex',
    //                 background: (theme) => alpha(theme.palette.background.paper, 0.9),
    //                 ...sx
    //             }}
    //         >
    //             <ExtraSmallButton sx={{ width: '30px', borderRadius: '0 !important' }} onClick={() => handleCustomSquareOffClick(position)}>
    //                 <ExitIcon fontSize="small" />
    //             </ExtraSmallButton>
    //         </Box>
    //     </NonInteractiveTooltip>
    // ), [handleCustomSquareOffClick, position])

    // const MoreVerticalOptions = useMemo(() => {
    //     if (!(position.open && showSquareOffButton && !(squaredOffPosition || sameOrderTypePosition))) {
    //         return null;
    //     }
    //     return (
    //         <Box
    //             style={{
    //                 position: 'absolute',
    //                 right: 0,
    //                 visibility: Boolean(menuAnchorEl) ? 'visible' : 'hidden',
    //                 top: 0,
    //                 height: '32px'
    //             }}
    //             sx={{
    //                 background: (theme) => alpha(theme.palette.background.paper, 0.9),
    //                 overflow: 'hidden',
    //                 whiteSpace: 'nowrap'
    //             }}
    //             className="hover-button"
    //         >
    //             <ExtraSmallButton size="small" onClick={handleClick} sx={{ float: 'right', p: 0, height: '32px', borderRadius: '0 !important' }}>
    //                 <MoreHorizontalIcon fontSize="small" />
    //             </ExtraSmallButton>
    //             <Menu
    //                 open={Boolean(menuAnchorEl)}
    //                 onClose={handleClose}
    //                 anchorEl={menuAnchorEl}
    //                 anchorOrigin={{
    //                     vertical: 'bottom',
    //                     horizontal: 'right',
    //                 }}
    //                 transformOrigin={{
    //                     vertical: 'top',
    //                     horizontal: 'right',
    //                 }}
    //                 disableAutoFocusItem
    //                 disableEnforceFocus
    //                 PaperProps={{
    //                     sx: {
    //                         ml: 1,
    //                         '& .MuiMenu-list': { paddingTop: 0, paddingBottom: 0, },
    //                     },
    //                 }}
    //             >
    //                 <MenuItem onClick={() => {
    //                     handleCustomSquareOffClick(position)
    //                     handleClose()
    //                 }} sx={{ px: '5px' }}>
    //                     <ListItemIcon sx={{ minWidth: '30px !important' }}>
    //                         <ExitIcon fontSize='small' />
    //                     </ListItemIcon>
    //                     <ListItemText>
    //                         <Typography fontSize={'12px'}>Square Off</Typography>
    //                     </ListItemText>
    //                 </MenuItem>
    //                 <MenuItem onClick={(e) => {
    //                     e.stopPropagation()
    //                     window.open(origin + `${generatePath(ROUTES.symbol, { symbol: getSecurityKey(position.security.exchange, position.security.code) })}`, '_blank')
    //                 }} sx={{ px: '5px' }}>
    //                     <ListItemIcon sx={{ minWidth: '30px !important' }}>
    //                         <Chart sx={{ height: '24px', width: '24px' }} strokeWidth={1} />
    //                     </ListItemIcon>
    //                     <ListItemText>
    //                         <Typography fontSize={'12px'}>Chart</Typography>
    //                     </ListItemText>
    //                 </MenuItem>
    //             </Menu>
    //         </Box>
    //     );
    // }, [position, showSquareOffButton, squaredOffPosition, sameOrderTypePosition, menuAnchorEl]);

    // return (
    //     <>
    //         <TableRow
    //             sx={{
    //                 borderBottom: '1.5px solid transparent',
    //                 position: 'relative',
    //                 opacity: (position.open ? 1 : 0.5) * (squaredOffPosition ? 0.5 : 1),
    //                 backgroundColor: basketId !== 'default' && strategyCode === 'CUSTOM' ? theme => alpha((theme.palette.mode === 'light') ? lightHoverBtnColor : darkHoverBtnColor, 0.3) : "none",
    //                 '&:hover .hover-button': {
    //                     visibility: 'visible !important'
    //                 },
    //                 '&.MuiTableRow-root td': {
    //                     background: (orderHoverDetect && hoveredOrderIndex?.includes(rowIndex)) ? theme => alpha(theme.palette.primary.main, 0.1) : 'none'
    //                 },
    //                 '&.MuiTableRow-root td:first-child': {
    //                     borderTopLeftRadius: '2px',
    //                     borderBottomLeftRadius: '2px'
    //                 },
    //                 '&.MuiTableRow-root td:last-child': {
    //                     borderTopRightRadius: '2px',
    //                     borderBottomRightRadius: '2px'
    //                 }
    //             }}
    //             onMouseEnter={() => orderHoverDetect && dispatch(setHoveredOrderIndex([rowIndex]))}
    //             onMouseLeave={() => orderHoverDetect && dispatch(setHoveredOrderIndex(undefined))}
    //         >
    //             <>
    //                 {<BasketPositionRowCells isSquaredOffOrder={false} hideAddedOrRemoved={!squaredOffPosition} isLastRow={isLastRow} />}
    //                 {
    //                     !squaredOffPosition ? ((strategyContainer && !sameOrderTypeQuantity) ? squareOffIcon() : null) : null
    //                 }
    //                 {MoreVerticalOptions}
    //                 {/* {position.open && showSquareOffButton && !(squaredOffPosition || sameOrderTypePosition) ? (
    //                     [squareOffIcon()].map((icon) => {
    //                         return icon
    //                     })
    //                 ) : null}  */}
    //             </>
    //         </TableRow>
    //         {showSquarredOffOrder && (
    //             <TableRow
    //                 sx={{
    //                     borderBottom: `1.5px solid transparent`
    //                 }}
    //             >
    //                 {<BasketPositionRowCells isSquaredOffOrder={true} hideAddedOrRemoved={false} isLastRow={isLastRow} />}
    //             </TableRow>
    //         )}
    //     </>
    // )
}

export default memo(BasketWisePositionContainer)


// TODO order service: uncomment